import './App.css';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Layout } from './Layout/main';
import { Routing } from './Routing/routing';
import { Loader } from './Layout/loader';

function App() {
  return (
    <div className="App">
      <Layout>
        <Loader />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          rtl={false}
        />
        <Routing />
      </Layout>
    </div>
  );
}

export default App;
